import { render } from "./ButtonActionComboardAttachment.vue?vue&type=template&id=cd8132f8"
import script from "./ButtonActionComboardAttachment.vue?vue&type=script&lang=js"
export * from "./ButtonActionComboardAttachment.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__